import swal from 'sweetalert2'

import type { MouseEvent } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload } from '@fortawesome/pro-light-svg-icons'

import { DashboardModuleListItem, Link } from '@domain-group/suit-theme'

import { AttachmentModel } from '@domain-group/realhub-backend-api-types'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useAttachment from '@hooks/useAttachment'

const confirmDelete = (
  deleteAttachment: (payload: HandleCallbackActionParams) => void,
  deleteFn: HandleCallbackActionParams['callbacks']['action'],
) => {
  const deleteAttachmentPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Attachment Deleted',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Delete File?',
    }).then(({ value }) => {
      if (value){
        deleteAttachment(deleteAttachmentPayload)
      }
    })
}

interface AttachmentListItemProps {
  attachment: AttachmentModel,
  boxProps?: object,
  callbacks?: {
    deleteAttachment: (payload: HandleCallbackActionParams) => void,
  },
}

const AttachmentListItem = (props: AttachmentListItemProps) => {
  const { attachment, boxProps, callbacks } = props
  const { deleteAttachment } = callbacks || {}

  const {
    dates,
    file_file_name,
  } = attachment

  const date_time = dates?.created?.date_time;

  const {
    callbacks: {
      deleteAttachment: deleteFn,
      downloadAttachment,
    },
  } = useAttachment(attachment)

  return (
    <DashboardModuleListItem boxProps={boxProps} isSidebar secondaryText={`Uploaded ${date_time}`} title={file_file_name}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        <Link greyLink onClick={(e: MouseEvent) => downloadAttachment(e)} textProps={{ marginRight: 'medium' }}>
          <FontAwesomeIcon icon={faFileDownload} />
        </Link>

        {deleteAttachment && (
          // @ts-expect-error TS2339
          <DashboardModuleListItem.Icon onClick={() => confirmDelete(deleteAttachment, deleteFn)} type="delete" />
        )}
      {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AttachmentListItem
